const handle = import.meta.env.VUE_APP_HANDLE;
const termsNL = 'https://zsmorthopedics.com/algemene-voorwaarden/';
const termsEN = 'https://zsmorthopedics.com/terms-and-conditions/';

const config = {
  image_field: import.meta.env.VUE_APP_IMAGE_FIELD ?? 'url',
  order_image_field: import.meta.env.VUE_APP_ORDER_IMAGE_FIELD ?? 'image_variant_1024',
  attribute_value_field: import.meta.env.VUE_APP_ATTRIBUTE_VALUE_FIELD ?? 'product_template_attribute_value_ids',
  portal_url: import.meta.env.VUE_APP_PORTAL_URL,
  finishing_enabled: handle === 'zsm',
  flea_enabled: true,
  bath_shoe_enabled: handle === 'zsm',
  techmed_enabled: handle === 'zsm',
  slippers_available: handle === 'zsm',
  osb_available: handle === 'zsm',
  osb_enabled: import.meta.env.VUE_APP_OSB_ENABLED === 'true',
  basics_enabled: import.meta.env.VUE_APP_BASICS_ENABLED === 'true',
  lutracad_enabled: handle !== 'zsm',
  terms: {
    nl: termsNL,
    en: termsEN,
    de: termsEN,
    fr: termsEN,
  },
};

const collections = {
  brigante: {
    name: 'Brigante',
    handle: 'brigante',
    slug: 'brigante',
  },
  classics: {
    name: 'Classics',
    handle: 'classics',
    slug: 'classics',
  },
  basics: {
    name: 'Basics',
    handle: 'basics',
    slug: 'basics',
  },
  flea: {
    name: 'Flea',
    handle: 'Vlos',
    slug: 'flea',
  },
};

const app = {
  schein: {
    collections: {
      ...collections,
      brigante: {
        name: 'CMS / Heritage',
        handle: 'brigante',
        slug: 'cms',
      },
      basics: {
        name: 'Evoline',
        handle: 'basics',
        slug: 'evoline',
      },
    },
    privacy_policy: 'https://schein.de/de/datenschutz.html',
    processing_agreement: 'https://schein.de/data/vertrag/Vertrag_Auftragsverarbeitung.pdf',
  },
};

export default {
  ...config,
  app: app[handle] || {
    collections,
  },
};
